var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E5ECF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 11.1654C21.3333 14.112 18.9467 16.4987 16 16.4987C13.0533 16.4987 10.6667 14.112 10.6667 11.1654C10.6667 8.2187 13.0533 5.83203 16 5.83203C18.9467 5.83203 21.3333 8.2187 21.3333 11.1654ZM5.33334 24.4987C5.33334 20.952 12.44 19.1654 16 19.1654C19.56 19.1654 26.6667 20.952 26.6667 24.4987V27.1654H5.33334V24.4987Z",
    fill: "#B2C5E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile1);
export default __webpack_public_path__ + "static/media/user-profile-1.1cab0385ad9d7eb6918f5cda6de4ade5.svg";
export { ForwardRef as ReactComponent };